/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  CircularProgress,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core';
import { gameBookTemplateActions, gameVariablesTemplateActions } from '@orientaction/api-actions';
import ContainerAdmin from '@orientaction/commons/ContainerAdmin';
import MarginContainer from '@orientaction/commons/MarginContainer';
import { Layout, ItemVariable, Modal } from '@orientaction/components';
import TestMainImage from '@orientaction/components/Admin/Test/Create/TestMainInfo/LeftImage/TestMainImage';
import { gameBookValues, gameVariables, gameVariableValues } from '@orientaction/reducers';
import { getFromLS, publicIconPath } from '@orientaction/utils';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import style from '../style';
import OaLabel from '@orientaction/commons/OaLabel';
import classNames from 'classnames';
import CloseIcon from '@material-ui/icons/HighlightOffOutlined';
import { cloneDeep, divide, pick, sortBy } from 'lodash';
import { apiServiceNative } from '../../../utils/fetchNative';
import { ReactComponent as Move } from '../../../Asset/svg/move.svg';
import { ReactComponent as Save } from '../../../Asset/svg/save.svg';
import { ReactComponent as Browser } from '../../../Asset/svg/browser.svg';
import Loader from '../EditPage/loader-edit';
import ModalEditGame from '../EditPage/modal-edit-game';

const Variables = (props: any) => {
  const classes = style();
  const valuesBooksTemplate = useSelector(gameBookValues);
  const valuesVariables = useSelector(gameVariables);
  const valuesVariablesGame = useSelector(gameVariableValues);
  const token = getFromLS('userToken') || '';
  const [loading, setLoading] = useState<boolean>(false);
  const [textLoading, setTextLoading] = useState<string>('');
  const history = useHistory();
  const dispatch = useDispatch();
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [variable, setVariable] = useState<string>('');
  const [error, setError] = useState<boolean>(false);
  const [variables, setVariables] = useState<any>([]);
  const [indexVariable, setIndexVariable] = useState<number>(0);
  const [openModalCancel, setOpenModalCancel] = useState<boolean>(false);
  const { edit }: any = useParams();

  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [openPublishModal, setOpenPublishModal] = useState<boolean>(false);
  const [openExitModal, setOpenExitModal] = useState<boolean>(false);

  const handleButtonClick = (index: number) => {
    setActiveIndex(index);
  };

  const getGameData = () => {
    const pagesRaw = sessionStorage.getItem('gamePages');
    const pages = pagesRaw ? JSON.parse(pagesRaw) : valuesBooksTemplate?.pages || [];
    return {
      ...valuesBooksTemplate,
      pages,
      variables_restitution: variables,
    };
  };

  const removePagesField = (array: any) =>
    array.map((obj: any) => {
      const { pages, ...rest } = obj;
      return rest;
    });

  const removeStringIds = (array: any) =>
    array.map((item: any) => {
      if (typeof item?.id === 'string') {
        delete item?.id;
      }
      return item;
    });

  const buildFormData = (gameData: any) => {
    const payload = removePagesField(gameData.pages);
    const formData = new FormData();

    gameData.pages.forEach((page: any, index: any) => {
      if (page.files) {
        formData.append(`file.img${index}`, page.files);
      }
    });
    formData.append('createdFrom', 'front_user');
    const title = gameData?.titlGame || gameData?.title || valuesBooksTemplate?.titlGame;
    if (title) {
      formData.append('title', title);
    }
    if (valuesBooksTemplate?.['file.img']) {
      formData.append('file.img', valuesBooksTemplate['file.img']);
    }
    formData.append('pagesList', JSON.stringify(removeStringIds(payload)));
    formData.append(
      'variables_restitution',
      JSON.stringify(gameData?.variables_restitution?.length > 0 ? gameData.variables_restitution : [])
    );
    formData.append('typeGame', gameData?.typeGame || 'classic');
    return formData;
  };

  const updateGame = async (idx: any, formData: any) => {
    const response = await apiServiceNative.put(`/api/update-game/${idx}`, formData, true);
    return response;
  };

  const updateCouve = async (idx: any, formData: any) => {
    sessionStorage.setItem('id', idx);
    await apiServiceNative.put(`/api/update-game-cover/${idx}`, formData, true);
  };

  const updateGameStatus = async (idX: any, isPublish: any) => {
    await apiServiceNative.put(`/api/change-status-game/${idX}`, {
      publishedAt: !!isPublish,
    });
  };

  const handleSaveGame = async (isPublish?: boolean) => {
    setLoading(true);
    setTextLoading(isPublish ? 'Publication en cours ...' : 'Sauvegarde en cours ...');
    try {
      const gameData = getGameData();
      const formData = buildFormData(gameData);
      let response;
      const gameId = sessionStorage.getItem('id');

      if (gameId) {
        await updateGameStatus(gameId, isPublish);
        await updateCouve(gameId, formData);
        response = await updateGame(gameId, formData);
      } else {
        const idsPages = gameData.pages.map((res: any) => res.id);
        const idsPagesString = idsPages.join(',');
        const idsVariables = gameData.variables_restitution?.map((res: any) => res.id) || [];
        const idsVariablesString = idsVariables.join(',');
        const idNews = await apiServiceNative.get(
          idsVariables.length > 0
            ? `/api/get-id-game?pageId=${idsPagesString}&variableIds=${idsVariablesString}`
            : `/api/get-id-game?pageId=${idsPagesString}`
        );
        await updateCouve(idNews, formData);
        response = await updateGame(idNews, formData);
        if (isPublish) {
          await updateGameStatus(idNews, isPublish);
        }
      }

      if (response) {
        dispatch(
          gameBookTemplateActions.updateField('variables_restitution', response?.variables_restitution)
        );
        if (response.id) {
          sessionStorage.setItem('id', response.id);
        }
        sessionStorage.removeItem('idPagesTemps');
        localStorage.removeItem('idFILESTemps');
        sessionStorage.removeItem('idVariablesTemps');
        sessionStorage.setItem('gamePages', JSON.stringify(response?.pages));
        sessionStorage.setItem('gameVariables', JSON.stringify(response?.variables_restitution));
      }
    } catch (err) {
      console.error('Erreur lors de la sauvegarde du jeu :', err);
    } finally {
      setLoading(false);
      setActiveIndex(null);
    }
  };

  const handleCloseModal = () => {
    setOpenPublishModal(false);
    setOpenExitModal(false);
    setActiveIndex(null);
  };

  const handleConfirmModal = () => {
    setActiveIndex(null);
    if (openExitModal) {
      setOpenExitModal(false);
      history.push('/admin/game/list');
    } else {
      handleSaveGame(true);
      setOpenPublishModal(false);
    }
  };

  const handleCancelModal = () => {
    setOpenPublishModal(false);
    setOpenExitModal(false);
    setActiveIndex(null);
  };

  const handleClose = () => {
    setOpenDrawer(false);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!variable.trim().length) {
      setError(true);
      return;
    }
    const { id: newId } = await apiServiceNative.post('/api/create-empty-variable', {
      name: variable,
      entity_id: sessionStorage.getItem('id'),
    });

    let idVariablesTemps = sessionStorage.getItem('idVariablesTemps') as any;

    if (!idVariablesTemps) {
      idVariablesTemps = [];
    } else {
      idVariablesTemps = JSON.parse(idVariablesTemps);
    }

    idVariablesTemps.push(newId);
    sessionStorage.setItem('idVariablesTemps', JSON.stringify(idVariablesTemps));

    setVariables((oldValues: any) => {
      const copieOldValues = cloneDeep(oldValues);
      const newVariable = {
        id: newId,
        name: variable,
      };
      copieOldValues.push(newVariable);
      dispatch(gameVariablesTemplateActions.setAllVariables(copieOldValues));
      return copieOldValues;
    });
    setOpenDrawer(false);
    setVariable('');
  };

  const handleNameChange = (e: any) => {
    setVariable(e.target.value);
    if (error) {
      setError(false);
    }
  };
  useEffect(() => {
    if (variables) {
      setIndexVariable(variables.length + 1);
    }
  }, [variables]);

  const handleChangeName = (index: number, name: string) => {
    const newValues = cloneDeep(variables);
    newValues[index].name = name;
    setVariables(newValues);
    dispatch(gameVariablesTemplateActions.setAllVariables(newValues));
  };
  const handleDelete = (index: number) => {
    setVariables((oldValues: any) => {
      const newData = cloneDeep(oldValues);
      newData.splice(index, 1);
      dispatch(gameVariablesTemplateActions.setAllVariables(newData));
      return newData;
    });
  };

  const handleDeleteRestitution = (index: number) => {
    setVariables((oldValues: any) => {
      const newData = cloneDeep(oldValues);
      const newDataItem = pick(newData[index], ['name', 'id']);
      newData[index] = {
        ...newDataItem,
        contentForType1: 'normal',
        contentForType2: 'normal',
        citationAuthor1: '',
        citationAuthor2: '',
        citationContent1: '',
        citationContent2: '',
        p1: '',
        p2: '',
        informationEncyclopedia1: '',
        informationEncyclopedia2: '',
      };
      dispatch(gameVariablesTemplateActions.setAllVariables(newData));
      return newData;
    });
  };

  const handleSubmitVariables = () => {
    dispatch(gameBookTemplateActions.updateField('variables_restitution', variables));
    sessionStorage.setItem('gameVariables', JSON.stringify(variables));
    if (!edit) {
      history.push('/admin/game/create');
    } else {
      history.push('/admin/game/edit/the-game');
    }
    dispatch(gameVariablesTemplateActions.setAllVariables([]));
  };

  useEffect(() => {
    if (valuesVariables && valuesVariables.length > 0) {
      setVariables(valuesVariables);
    }
  }, [valuesVariables]);

  useEffect(() => {
    const variablesRestitution = valuesBooksTemplate?.variables_restitution;
    if (variablesRestitution && variablesRestitution.length > 0) {
      if (!valuesVariables || valuesVariables?.length === 0) {
        dispatch(
          gameVariablesTemplateActions.setAllVariables(variablesRestitution)
        );
      }
      // setVariables(valuesBooksTemplate?.variables_restitution);
    }
  }, [valuesBooksTemplate]);

  const confirmCancel = () => {
    if (!edit) {
      history.push('/admin/game/create');
    } else {
      history.push('/admin/game/edit/the-game');
    }
    dispatch(gameVariablesTemplateActions.setAllVariables([]));
  };

  return (
    <>
      <ModalEditGame
        open={openPublishModal || openExitModal}
        handleClose={handleCloseModal}
        title={valuesBooksTemplate?.titlGame || valuesBooksTemplate?.title || ''}
        message={
          openPublishModal
            ? 'Vous êtes sur le point de publier le jeu'
            : "Êtes-vous sûr de vouloir quitter l'édition du jeu ?"
        }
        onCancel={handleCancelModal}
        onConfirm={handleConfirmModal}
      />
      <Loader open={loading} text={textLoading} />
      <Layout isaddBackground={true} showOverFlow={true}>
        <ContainerAdmin>
          <MarginContainer big={true}>
            <div className={classes.inner} style={{ justifyContent: 'flex-start', gap: 10, marginBottom: 0, paddingBottom: 0 }}>
              <div className={`${classes.wrapbutton} ${activeIndex === 0 ? 'active' : ''}`} style={{ paddingBottom: 0 }}>
                <IconButton
                  aria-label="exit"
                  className={classes.iconButton}
                  onClick={() => {
                    handleButtonClick(0);
                    setOpenExitModal(true);
                  }}>
                  <Move className={classes.icon} />
                </IconButton>
                <div className={classes.tooltipLabel}>Quitter sans sauvegarder</div>
              </div>
              <div className={`${classes.wrapbutton} ${activeIndex === 1 ? 'active' : ''}`} style={{ paddingBottom: 0 }}>
                <IconButton
                  aria-label="save"
                  className={classes.iconButton}
                  onClick={() => {
                    handleButtonClick(1);
                    handleSaveGame();
                  }}>
                  <Save className={classes.icon} />
                </IconButton>
                <div className={classes.tooltipLabel}>Sauvegarder comme brouillon</div>
              </div>
              <div className={`${classes.wrapbutton} ${activeIndex === 2 ? 'active' : ''}`} style={{ paddingBottom: 0 }}>
                <IconButton
                  aria-label="publish"
                  className={classes.iconButton}
                  onClick={() => {
                    handleButtonClick(2);
                    setOpenPublishModal(true);
                  }}>
                  <Browser className={classes.icon} />
                </IconButton>
                <div className={classes.tooltipLabel}>Publier</div>
              </div>
            </div>
            <Grid
              container={true}
              spacing={2}
              direction="row"
              justifyContent="center"
              alignItems="center">
              <Grid item={true} sm={12} style={{ position: 'relative' }}>
                <Typography variant="h2" style={{ textTransform: 'none', textAlign: 'center' }}>
                  Variables associées au jeu
                </Typography>
                <div
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                  }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenDrawer(true)}
                    className={classes.btnPrimary}>
                    Ajouter une variable
                  </Button>
                </div>
              </Grid>
            </Grid>
            <span className={classes.separator} />
            {variables && variables.length > 0 && (
              <Grid container={true} direction="row" justifyContent="center" alignItems="stretch">
                <Grid item={true} sm={5} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Typography className={classes.summaryTextH6} variant="h6">
                    Variables
                  </Typography>
                </Grid>
                <Grid item={true} sm={4} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Typography className={classes.summaryTextH6} variant="h6">
                    Restitutions
                  </Typography>
                </Grid>
              </Grid>
            )}
            <div className={classes.blockItemsVariable}>
              {variables && variables.length > 0 ? (
                variables.map((el: any, index: number) => (
                  <div key={`${el.name + index}`} style={{ marginTop: 10 }}>
                    <ItemVariable
                      key={`${el.name + index}`}
                      name={el.name}
                      index={index + 1}
                      handleChangeName={handleChangeName}
                      handleDelete={handleDelete}
                      dataVariable={el}
                      handleDeleteRestitution={handleDeleteRestitution}
                      edit={!!edit}
                    />
                  </div>
                ))
              ) : (
                <div className={classes.textEmptyVariable}>
                  <Typography variant="h5" style={{ textTransform: 'none', textAlign: 'center' }}>
                    Aucune variable
                  </Typography>
                </div>
              )}
            </div>
          </MarginContainer>
        </ContainerAdmin>
        <Drawer
          anchor="right"
          open={openDrawer}
          classes={{ root: classes.rootStyle, paper: classes.drawerContent }}>
          <div className={classes.headerContainer}>
            <IconButton className={classes.closeBtnDrawer} onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
            <div className={classes.titleContainer}>
              <Typography variant="h3" className={classes.titleDrawer}>
                Ajouter une variable
              </Typography>
            </div>
          </div>
          <div className={classes.contentChild}>
            <form onSubmit={handleSubmit}>
              <Typography className={classes.variableFormTitle} component="h3">
                Variable {`N°${indexVariable}`}
              </Typography>
              <div>
                <OaLabel>Nom de la variable</OaLabel>
                <TextField
                  id="test-variable-name"
                  variant="outlined"
                  className={classNames(classes.formInput, error && classes.error)}
                  name="variableName"
                  value={variable}
                  onChange={handleNameChange}
                />
              </div>
              <div className={classes.marginTop}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.btnPrimary}>
                  Valider
                </Button>
              </div>
            </form>
          </div>
        </Drawer>
      </Layout>
      <div className={classes.footerWrapper}>
        <div>
          <Button
            variant="outlined"
            className={classes.button}
            onClick={() => setOpenModalCancel(true)}>
            Annuler
          </Button>
          <Button
            variant="contained"
            color="primary"
            id="draft-submit"
            onClick={handleSubmitVariables}
            className={classes.btnPrimarySticky}>
            Valider
          </Button>
        </div>
        <Typography variant="h3" className={classes.text}>
          (Pensez à sauvegarder votre travail dans l'éditeur de page)
        </Typography>
      </div>
      <Modal
        data-cy="cancel-test-create-modal"
        open={openModalCancel}
        onCancel={() => setOpenModalCancel(false)}
        onConfirm={confirmCancel}
        textCancel="Non"
        title=""
        textValidate="Oui">
        <h3 style={{ color: '#000A8C' }}>
          Êtes-vous sûr de vouloir annuler les modifications que vous avez apportées aux variables
          de ce jeu ?
        </h3>
      </Modal>
    </>
  );
};

export default Variables;
